import React, { useState, useEffect, Fragment } from 'react';
import { AuthContext } from '../components/AuthProvider';

import {
	post_scan_tokens,
} from "../tools-network";

import { showTemporaryMessage } from "../components/Message";

const AddScanTokens = ({scanTokensAdded}) => {
	const { userType, loginToken, userId } = React.useContext(AuthContext);
	const isAdminUser = userType === 'ADMIN';

	const [bearerDetails, setBearerDetails]							= useState(null);
	const [showPostNewScanTokensDiv, setShowPostNewScanTokensDiv]	= useState(false);
	const [submitGuiEnabled, setSubmitGuiEnabled]					= useState(true);
	const [numberOfNewScanTokens, setNumberOfNewScanTokens]			= useState(1);

	useEffect(() => {
	    if (!/^\d*$/.test(numberOfNewScanTokens)) {
	        setNumberOfNewScanTokens(1); // Reset to empty if it contains non-numeric input
	    }
	}, [numberOfNewScanTokens]);

	const onPostScanTokensClicked = async () => {
		console.log("Fake posting: " + numberOfNewScanTokens);
		try {
			const res = await post_scan_tokens(loginToken, numberOfNewScanTokens);
			if(res.status) {
				const tokens_created = res.count;
				console.log("COUNT: " + tokens_created);
				scanTokensAdded();
				showTemporaryMessage(tokens_created + " scan tokens created.");
				setNumberOfNewScanTokens(1);
			} else {
				showTemporaryMessage("Creating new scan tokens FAILED!", res.msg, 'danger');
			}
		} catch (err) {
			showTemporaryMessage("Creating new scan tokens FAILED!", err, 'danger');
		}
	};

	return (
		<>
			{/* User details display */}					
				<div className="flex flex-col w-full h-auto neumorp text-center justify-top items-center p-4">
					<>
						<h2 className="font-bold text-xl mb-1">Create new QR codes</h2>

						{/* ENABLE CREATE NEW SCAN TOKENS DIV */}
						{!showPostNewScanTokensDiv &&
							<div
								id="create-new-scan-tokens-enable"
								className="w-full">
								<button
									onClick={() =>
										{setShowPostNewScanTokensDiv(true);}}
									className="btn-main disabled:bg-gray-300">
											Add new QR codes {/* I this title necessary? */}
								</button>
							</div>			
						}

						{/* ACTUAL CREATE NEW SCAN TOKENS DIV */}
						{showPostNewScanTokensDiv &&
						<form>
							<div className="flex flex-col w-full gap-2 items-center py-4">
								<div className="flex w-full justify-start">
									<h3 className="text-xl font-lucida font-semibold">New QR codes</h3>
								</div>
								<div className="flex items-center w-full">
									<label htmlFor="password" className="text-sm font-bold leading-4 text-gray-700 mr-1 text-nowrap">
										Number of QR codes:
									</label>
									<input
										disabled={!submitGuiEnabled}
										type="text"
										inputMode="numeric" // Mobile devices will show numeric keyboard
										id="number-of-scan-tokens"
										value={numberOfNewScanTokens}
										onChange={(e) => {
												const value = e.target.value;
												if (/^\d*$/.test(value)) { // Regular expression to allow only digits
													setNumberOfNewScanTokens(value);
												}
										}}
										className="block w-full rounded-md border border-gray-300 px-2 py-1 text-gray-900 shadow-sm focus-within:ring-1 focus-within:ring-inset focus-within:ring-cyan-600 sm:max-w-md sm:text-sm leading-4"
									/>
								</div>

								<div className="flex w-full items-center justify-between mt-3 gap-4">
									{/* SUBMIT POST SCAN TOKENS*/}
									<button onClick={() =>
										{ onPostScanTokensClicked();
										setShowPostNewScanTokensDiv(false); }}
										id='create-new-scan-tokens-submit'
										disabled={!submitGuiEnabled}
										className="btn-main w-full text-white px-4 py-2 rounded-md text-center text-sm disabled:bg-gray-400 disabled:cursor-not-allowed transition ease-in-out hover:-translate-y-0.5 hover:scale-105"
										>
											Submit new QR codes
									</button>
									{/* CANCEL POST SCAN TOKENS */}
									<button onClick={() =>
										{ setNumberOfNewScanTokens(1);
										setShowPostNewScanTokensDiv(false); }}
										className="w-auto text-red-700 px-3 py-1 rounded-md text-center text-danger-700 font-semibold text-sm disabled:bg-gray-400 disabled:cursor-not-allowed hover:text-black">
											Cancel
									</button>
								</div>
							</div>
						</form>
						}
					</>
			</div>
		</>
	);
};

export default AddScanTokens;

